import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'src/styles/theme';

import classes from './style/NoMatch.module.css';

export default function NoMatch() {
  const { t } = useTranslation();
  const theme = useTheme();
  const renderContent = () => {
    return (
      <Flex className={classes.container} justify="center" vertical>
        <img
          src="/assets/noData.gif"
          width={124}
          height={124}
          className={classes.content}
        />
        <Flex vertical className={classes.content}>
          <p className={`${theme.fonts.classNames.subPageTitleWhite}`}>
            {t('noMatchScreen.title')}
          </p>
          <p className={`${theme.fonts.classNames.pageTitle}`}>
            {t('noMatchScreen.subtitle')}
          </p>
        </Flex>
      </Flex>
    );
  };

  return <>{renderContent()}</>;
}
